import { useParams } from 'react-router-dom'
import { useMainContext } from '../../../../../core/contexts/main'
import DetailsLayout from '../../../../layout/main/DetailsLayout'
import {
    DetailRow,
    LeftHeadDecoration,
    RightHeadDecoration,
} from '../../../../../styles/main/MainCommonStyles'
import { DText, Flex } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import { formatDate } from '../../../../../core/utils/common'
import {
    useGetAnAccount,
    useGetAnAccountLatestStatus,
    useGetRFI,
    useGetSubmissionLink,
    useResubmitVa,
} from '../../../../../core/services/react-query/report/due-payments'
import UserLink from '../../../../common/utils/UserLink'
import { useEffect, useRef, useState } from 'react'
import ModalLayout from '../../../../layout/main/ModalLayout'
import BasicModal from '../../../../modals/BasicModal'
import ActionButton from '../../../../common/buttons/ActionButton'
import { PulseLoader } from 'react-spinners'
import CopyText from '../../../../common/utils/CopyText'
import { useQueryContext } from '../../../../../core/contexts/query'
import { flattenLatestStatus, parseFiatAccountDetails, parseRFIData } from './parsers'

const FiatAccountDetails = ({ detailId, user }) => {
    const params = useParams()
    const rifDetailsRef = useRef();
    const { lang } = useMainContext();
    const [userId, setUserId] = useState(null)
    const [ksubId, setKsubId] = useState(null)
    const [enableLatestStatus, setEnableLatestStatus] = useState(null)
    const [updateLatestStatus, setUpdateLatestStatus] = useState(null)
    const [enabledRFI, setEnabledRFI] = useState(null)
    const [modal, setModal] = useState({ open: false, account: null })

    const {
        data: fiatAccount,
        isFetching,
        isError,
    } = useGetAnAccount(detailId || params.detailId)

    const {
        data: RFIData,
        isLoading: RFIisLoading,
        isFetching: RFIisFetching,
    } = useGetRFI(userId, enabledRFI, () => {
        setUserId(null)
        setEnabledRFI(null)
    })
    const {
        data: accountLatestStatus,
        isLoading: latestStatusisLoading,
        isFetching: latestStatusisFetching,
    } = useGetAnAccountLatestStatus(userId, enableLatestStatus, updateLatestStatus, () => {
        setUserId(null)
        setEnableLatestStatus(null)
        setUpdateLatestStatus(null)
    })
    // accountLatestStatus?.data

    const {
        data: submissionLink,
        isLoading: submissionLinkIsLoading,
    } = useGetSubmissionLink(ksubId, userId, () => {
        setKsubId(null)
        setUserId(null)
    })


    const onCloseModal = () => {
        setModal({ open: false, account: null })
    }

    const { mutate, isLoading } = useResubmitVa(onCloseModal)

    const detailsRows = parseFiatAccountDetails(fiatAccount);
    const rfiDetails = parseRFIData(RFIData);

    const hasRFI = rfiDetails.length > 0;


    const latestStatusRows = flattenLatestStatus(accountLatestStatus?.data);

    useEffect(() => {
        if (hasRFI && rifDetailsRef.current) {
            rifDetailsRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
        }
    }, [hasRFI])

    return (
        <>
            <DetailsLayout
                isFetching={isFetching}
                isError={isError}
                type={fiatAccount?.meta?.isValid ? 'VALID' : 'INVALID'}
            >
                <LeftHeadDecoration left={'10px'}>
                    <Flex>
                        <ActionButton
                            active
                            width="120px"
                            height="40px"
                            onClick={() =>
                                setModal({
                                    open: true,
                                    account: fiatAccount,
                                })
                            }
                        >
                            <Text tid="Resubmit KYC" className="text-xs" />
                        </ActionButton>

                        <ActionButton
                            active
                            width="120px"
                            height="40px"
                            onClick={() => {
                                setUserId(fiatAccount?.userId)
                                setEnabledRFI(true)
                            }}
                        >
                            {RFIisLoading || RFIisFetching ? (
                                <PulseLoader size={5} />
                            ) : (
                                <Text tid="Get RFI" className="text-xs" />
                            )}
                        </ActionButton>
                        <ActionButton
                            active
                            width="120px"
                            height="40px"
                            onClick={() => {
                                setUserId(fiatAccount?.userId)
                                setEnableLatestStatus(true)
                            }}
                        >
                            {latestStatusisLoading || latestStatusisFetching ? (
                                <PulseLoader size={5} />
                            ) : (
                                <Text tid="Get Latest Status" className="text-xs" />
                            )}
                        </ActionButton>
                    </Flex>
                </LeftHeadDecoration>

                <RightHeadDecoration right="10px">
                    <DText main className="text-nowrap">
                        <Text tid="fiatAccount-details" />
                    </DText>
                </RightHeadDecoration>

                <DetailRow>
                    <DText main>
                        <Text tid="user" />
                    </DText>

                    <Flex justify="flex-end">
                        <UserLink
                            _id={fiatAccount?.userId}
                            name={fiatAccount?.userId}
                        />
                    </Flex>
                </DetailRow>

                {detailsRows.map((item) => (
                    <DetailRow key={item.key}>
                        <DText main>{item.key}</DText>

                        <Flex justify="flex-end">
                            <DText primary lineBreak="anywhere">
                                {item.value}
                            </DText>
                        </Flex>
                    </DetailRow>
                ))}


                {/* LATEST STATUS */}
                {latestStatusRows?.length > 0 && (
                    <>
                        <Flex
                            fw
                            justify="space-between"
                            style={{
                                marginTop: '30px',
                                marginBottom: '10px',
                            }}
                        >
                            <ActionButton
                                active
                                width="120px"
                                height="40px"
                                onClick={() => {
                                    setUserId(fiatAccount?.userId)
                                    setEnableLatestStatus(true);
                                    setUpdateLatestStatus(true);
                                }}
                            >
                                {latestStatusisLoading || latestStatusisFetching ? (
                                    <PulseLoader size={5} />
                                ) : (
                                    <Text tid="Update Status" className="text-xs" />
                                )}
                            </ActionButton>
                            <DText main>
                                <Text tid="Latest Status" />
                            </DText>
                        </Flex>

                        {latestStatusRows.map((item) => (
                            <DetailRow key={item.key}>
                                <DText main>{item.key}</DText>

                                <Flex justify="flex-end">
                                    <DText primary lineBreak="anywhere">
                                        {String(item.value)}
                                    </DText>
                                </Flex>
                            </DetailRow>
                        ))}
                    </>
                )}


                {/* RFI */}
                {hasRFI && (
                    <>
                        <Flex
                            ref={rifDetailsRef}
                            fw
                            justify="space-between"
                            style={{
                                marginTop: '30px',
                                marginBottom: '10px',
                            }}
                        >
                            <DText main>
                                <Text tid="RFI Details" />
                            </DText>
                        </Flex>

                        {rfiDetails.map((item) => {
                            if (item.key === 'Submission ID') {
                                return (
                                    <div key={item.key}>
                                        <DetailRow >
                                            <DText main>{item.key}</DText>

                                            <Flex
                                                justify="flex-end"
                                                align="center"
                                                gap="10px"
                                            >
                                                <ActionButton
                                                    active
                                                    width="160px"
                                                    height="32px"
                                                    onClick={() => {
                                                        setUserId(fiatAccount?.userId)
                                                        setKsubId(item.value)
                                                    }}
                                                >
                                                    {submissionLinkIsLoading ? (
                                                        <PulseLoader size={5} />
                                                    ) : (
                                                        <Text
                                                            tid="Get Submission Link"
                                                            className="text-xs"
                                                        />
                                                    )}
                                                </ActionButton>
                                                <DText primary lineBreak="anywhere">
                                                    {item.value}
                                                </DText>

                                            </Flex>
                                        </DetailRow>
                                        {submissionLink?.data && (
                                            <DetailRow>
                                                <DText main>
                                                    Submission Link
                                                </DText>

                                                <Flex>
                                                    <CopyText text={submissionLink.data} maxWidth={"120px"} justify={"end"} />
                                                </Flex>
                                            </DetailRow>
                                        )}
                                    </div>

                                )
                            }


                            return (
                                <DetailRow key={item.key}>
                                    <DText main>{item.key}</DText>

                                    <Flex justify="flex-end">
                                        <DText primary lineBreak="anywhere">
                                            {item.value}
                                        </DText>
                                    </Flex>
                                </DetailRow>
                            )
                        })}
                    </>
                )}

                {/* CREATED AT */}
                <Flex
                    fw
                    justify="space-between"
                    style={{ marginTop: '20px' }}
                >
                    <DText main>
                        {formatDate(
                            fiatAccount?.createdAt,
                            'date',
                            lang
                        )}
                    </DText>

                    <DText main>
                        {formatDate(
                            fiatAccount?.createdAt,
                            'time',
                            lang
                        )}
                    </DText>
                </Flex>
            </DetailsLayout>

            <ModalLayout
                width="550px"
                open={modal?.open}
                onClose={onCloseModal}
            >
                <BasicModal
                    onClose={onCloseModal}
                    onSubmit={() => {
                        mutate(modal?.account?.userId)
                    }}
                    loading={isLoading}
                    head="resubmit-account-kyc"
                    desc="are-you-sure-to-resubmit-kyc"
                    _id={modal?.account?.user?.email}
                />
            </ModalLayout>
        </>
    )
}

export default FiatAccountDetails
